/**
 * Emit hosts for the `export-settings` analytics group — 2 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  type ExportContentSavedEventProps,
  type ExportSettingScope,
  type ExportSettingType,
} from '@/models/analytics/features/export-settings';

export function exportContentSaved(props: ExportContentSavedEventProps) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ExportContentSaved,
    props,
  });
}

// Export Header/Footer Settings (consolidated)
export function exportSettingToggled({
  type,
  enabled,
  scope,
  teamId,
}: {
  type: ExportSettingType;
  enabled: boolean;
  scope: ExportSettingScope;
  teamId?: string;
}) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ExportSettingToggled,
    props: {
      type,
      enabled,
      scope,
      ...(teamId && { team_id: teamId }),
    },
  });
}
